import React, { useState, useEffect, useRef } from "react";

import {connect} from 'react-redux';
import {format} from "date-fns"
import { TrashIcon, ArrowUturnLeftIcon } from "@/icons/outline";
import { convertDate } from "./timesheetImportHelpers";

const WarningRow = ({item,rowClass,setItem,disableEditing}) => {


  const [visibleItem, setVisibleItem] = useState({
      ...item,
      timeInValid: true,
      timeOutValid: true
    });

  const isNumber = (a) => (!isNaN(a))

  useEffect(() => {
    setVisibleItem({
      ...item,
      timeInValid: true,
      timeOutValid: true
    });
    // const collapseAll = {}
    // Object.keys(employeeByReference).map(reference => { collapseAll[reference] = true } )
    // console.log('collapse',collapseAll)
    // employeeByReference && setCollapse( collapseAll )
  },[item])

  const calculateHours = (item) => {

    const from = item['time-in']
    const to = item['time-out']
    let breakTime = 0

    let hoursFrom = parseInt(from.split(':')[0])
    let hoursTo = parseInt(to.split(':')[0])

    let minsFrom = parseInt(from.split(':')[1])
    let minsTo = parseInt(to.split(':')[1])


    if (minsTo < minsFrom) {
      minsTo += 60;
      hoursTo -= 1;
    }

    if (hoursTo < hoursFrom) {
      hoursTo += 24;
    }

    if (isNumber(item['break'])){
      breakTime = parseInt(item['break'])
    }

    const hours = Math.round((hoursTo - hoursFrom + ((minsTo - minsFrom - breakTime )/ 60)) * 100)/100;

    item.hours = hours;


    setVisibleItem(item);

  }

  const skipRow = (skip) => {
    // set skip flag
    setItem({
      ...visibleItem,
      skip: skip
    })
    // save new item state
  }

  const approveChange = () => {
    // save new item state
    setItem({
      ...visibleItem,
      updated: true
    })
  }

  const showItem = visibleItem || item

  // console.log('showItem',showItem)

  const isValid = visibleItem.timeInValid && visibleItem.timeOutValid

  if (!item){
    return null;
  }

  return <tr role="row" className={rowClass} style={{
    opacity: visibleItem.skip ? 0.4 : 1
  }}>

    <td colSpan='2'>
      {item.leave && <span className='badge badge-warning'>On Leave for {item.leave.hours && parseFloat(item.leave.hours).toFixed(2)} hours</span>}
    </td>
    <td>{format(new Date(convertDate(showItem.date)),"do MMM yyyy")}</td>
    <td>
      <input onChange={(e) => {
        if (!showItem['original-time-in']){
          showItem['original-time-in'] = showItem['time-in'];
        }

        const newItem = {...showItem};

        newItem['time-in'] = e.target.value

        const regex = RegExp('^\\d{2}:\\d{2}$');
        newItem.timeInValid = regex.test(e.target.value);
        newItem.edited = true;
        newItem.updated = false;

        calculateHours(newItem)

      }} style={{maxWidth:"50px"}} value={showItem['time-in']} />
    </td>
    <td>
      <input onChange={(e) => {
        if (!showItem['original-time-out']){
          showItem['original-time-out'] = showItem['time-out'];
        }

        const newItem = {...showItem};

        newItem['time-out'] = e.target.value

        const regex = RegExp('^\\d{2}:\\d{2}$');
        newItem.timeOutValid = regex.test(e.target.value);
        newItem.edited = true;
        newItem.updated = false;

        calculateHours(newItem);

      }} style={{maxWidth:"50px"}} value={showItem['time-out']} />
    </td>
    <td>{showItem.hours}</td>
    <td>{showItem.break}</td>
    <td>
      {!disableEditing && showItem.skip && <div className='btn btn-success' onClick={() => skipRow(false)}><ArrowUturnLeftIcon className="w-6 h-6 media-middle"/></div>}
      {showItem.updated && <div className="btn">Saved</div>}
      {!showItem.updated && !showItem.skip && (!showItem.edited ? <div className='btn btn-xs btn-danger' onClick={() => skipRow(true)}><TrashIcon className="w-6 h-6 media-middle"/></div> : <div className={'btn btn-'.concat(isValid ? 'success' : 'danger')} onClick={approveChange} disabled={!isValid}>Approve Change</div>)}

    </td>

  </tr>
}

const mapStateToProps = (state,ownProps) => {

  let {item,itemIndex} = ownProps;

  if (!item && itemIndex){
    item = state.timesheetImport.dataToSend[itemIndex]
  }

  return {
    item
  }
}

const mapDispatchToProps = dispatch => ({

  // processWarnings: () => dispatch(TIMESHEET_IMPORT_ACTIONS.processWarnings()),
  
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WarningRow) 
